import React from 'react';
import styled from 'styled-components';

import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Avatar,
  Typography,
} from '@material-ui/core';

import { red } from '@material-ui/core/colors';

import { Container, Section } from '../global';

const StyledSection = styled(Section)`
  /* padding-top: 0px; */
  background-color: ${(props) => props.theme.color.background.light};
  /* clip-path: polygon(0 7%, 100% 4%, 100% 100%, 0% 100%); */
  /* clip-path: polygon(0 0, 100% 14%, 100% 100%, 0% 100%); */
`;

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 80px 0 0px;
`;

const GetStartedTitle = styled.h3`
  margin: 0 auto 32px;
  text-align: center;
`;

const QuoteCard = () => (
  <Card style={{ maxWidth: 345, margin: 10, minWidth: 300 }}>
    <CardHeader
      avatar={
        <Avatar aria-label="recipe" style={{ backgroundColor: red[500] }}>
          KG
        </Avatar>
      }
      title="Kovács Géza"
      subheader="Barbershop Kozpont"
    />
    <CardContent>
      <Typography variant="body2" color="textSecondary" component="p">
        This impressive paella is a perfect party dish and a fun meal to cook
        together with your guests. Add 1 cup of frozen peas along with the
        mussels, if you like.
      </Typography>
    </CardContent>
  </Card>
);

const References = () => (
  <StyledSection id="referenciák">
    <StyledContainer>
      <GetStartedTitle>Referenciák</GetStartedTitle>
      <Box display="flex" width="100%" flexWrap="wrap" justifyContent="center">
        <QuoteCard />
        <QuoteCard />
        <QuoteCard />
        <QuoteCard />
        <QuoteCard />
        <QuoteCard />
        <QuoteCard />
        <QuoteCard />
      </Box>
    </StyledContainer>
  </StyledSection>
);

export default References;
